<template>
  <div>
    <router-view v-show="isLoading"></router-view>
    <OpenPage  v-show="!isLoading"></OpenPage>
  </div>
</template>

<script>
import OpenPage from "./layout/OpenPage";
export default {
  name: "app",
  components: {
    OpenPage,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {},
  created() {
    if(sessionStorage.getItem('isLoading')){
      this.isLoading = sessionStorage.getItem('isLoading')
    }else{
      this.isLoading = false
    }
  },
  mounted() {
    let that = this;
    // this.$nextTick(function(){
    //   that.isLoading = true
    // })
    setTimeout(() => {
      sessionStorage.setItem('isLoading',that.isLoading)
      that.isLoading = true;
    }, 2200);
  },
};
</script>

<style>
#app {
  font-family: PingFang SC;
}


/* //变灰色 */
/* html {
    filter: gray; 
    filter: grayscale(0.95); 
    -webkit-filter: grayscale(.95);
} */
</style>
